import React, { useMemo, useState } from 'react';
import {
  Box,
  FormControl,
  InputLabel,
  MenuItem,
  Select,
  TableContainer,
  TableCell,
  TableRow,
  Table,
  TableHead,
  TableBody,
  TableFooter,
  FormHelperText
} from '@mui/material';
import { getProgramEntity, getFeatureDetaileByInstanceType, saveProgramFeatureDetailsByProgramType } from 'api/api';
import axiosInstance from 'interceptors/axiosInstance';
import { getInitialState, SumofCoulmn, currencyFormatter } from 'views/versions/tabs/Constfunctions';
import Spinnerprogress from 'ui-component/circular-progress/Spinnerprogress';

const ProgramSetup = ({ view, EstimationId, ClientId, ProjectId, Version, formState, setFormState }) => {
  const [isLoading, setIsLoading] = useState(false);
  const [entityType, setEntityType] = useState({
    InstanceTypeValue: [],
    ProgramTypeValue: []
  });

  const [rows, setRows] = useState([]);
  const [error, setError] = useState({
    InstanceTypeValue: false,
    ProgramTypeValue: false
  });
  const [devtotal, setDevTotal] = useState({
    DevHrs: 0,
    QAHrs: 0,
    TotalHrs: 0,
    TotalCost: 0
  });

  //const [pmTotal, setPmTotal] = useState({ pmHrs: 0, pmCost: 0 });
  //const [leadDevTotal, setLeadDevTotal] = useState({ leadDevHrs: 0, leadDevCost: 0 });

  const handleChange = (e) => {
    const { name, value } = e.target;
    // For saving the changes
    if (name === 'InstanceTypeValue' && formState.ProgramTypeValue !== 'NA' && value !== 'NA') {
      handleSave(value, formState.ProgramTypeValue);
    } else if (name === 'ProgramTypeValue' && formState.InstanceTypeValue !== 'NA' && value !== 'NA') {
      handleSave(formState.InstanceTypeValue, value);
    }

    if (value !== 'NA') {
      setError({ ...error, [name]: false });
    } else if (value === 'NA') {
      setError({ ...error, [name]: true });
    }
    setFormState({ ...formState, [name]: value });
  };

  const handleSave = async (instanceType, programType) => {
    await axiosInstance
      .post(`${saveProgramFeatureDetailsByProgramType}`, {
        InstanceType: instanceType,
        ProgramType: programType,
        ClientId: ClientId,
        ProjectId: ProjectId,
        EstimationID: EstimationId,
        Version: Version
      })
      .catch((error) => console.log(error));
  };

  useState(() => {
    setIsLoading(true);
    const fetchData = async () => {
      const instanceRes = await axiosInstance
        .get(`${getProgramEntity}?EntityType=Instance Type&EstimationId=${EstimationId}`)
        .catch((error) => console.log(error));
      const programRes = await axiosInstance
        .get(`${getProgramEntity}?EntityType=Feature Program Type&EstimationId=${EstimationId}`)
        .catch((error) => console.log(error));

      setEntityType({
        ...entityType,
        InstanceTypeValue: instanceRes.data,
        ProgramTypeValue: programRes.data
      });

      setFormState({
        ...formState,
        InstanceTypeValue: getInitialState(instanceRes.data),
        ProgramTypeValue: getInitialState(programRes.data)
      });
    };
    setIsLoading(false);
    fetchData();
  }, []);

  useMemo(async () => {
    if (formState.InstanceTypeValue !== 'NA' && formState.ProgramTypeValue !== 'NA') {
      await axiosInstance
        .get(`${getFeatureDetaileByInstanceType}`, {
          params: {
            InstanceType: formState.InstanceTypeValue,
            ProgramType: formState.ProgramTypeValue
          }
        })
        .then((response) => {
          setRows(response.data);
        })
        .catch((error) => console.log(error));
    }
  }, [formState]);

  useMemo(() => {
    if (rows.length > 0) {
      setDevTotal({
        DevHrs: SumofCoulmn(rows, 'DevHrs'),
        QAHrs: SumofCoulmn(rows, 'QAHrs'),
        TotalHrs: SumofCoulmn(rows, 'TotalHrs'),
        TotalCost: SumofCoulmn(rows, 'TotalCost')
      });
    }
  }, [rows]);

  // useMemo(() => {
  //   setPmTotal({ pmHrs: devtotal.TotalHrs * 0.3, pmCost: devtotal.TotalHrs * 0.3 * 101 });
  //   setLeadDevTotal({ leadDevHrs: devtotal.TotalHrs * 0.3, leadDevCost: devtotal.TotalHrs * 0.3 * 94 });
  // }, [devtotal]);

  return (
    <>
      {isLoading ? (
        <Spinnerprogress />
      ) : (
        <Box>
          <FormControl disabled={view} variant="filled" sx={{ m: 1, minWidth: 260 }} error={error.InstanceTypeValue}>
            <InputLabel id="instance-type-label">Instance Type</InputLabel>
            <Select
              labelId="instance-type-label"
              id="instance-type"
              name="InstanceTypeValue"
              value={formState.InstanceTypeValue}
              onChange={handleChange}
            >
              {entityType.InstanceTypeValue.map((item, index) => {
                return (
                  <MenuItem key={index + item.Text} value={item.Text}>
                    {item.Text}
                  </MenuItem>
                );
              })}
            </Select>
            {error.InstanceTypeValue && <FormHelperText>Please select valid Instance Type</FormHelperText>}
          </FormControl>
          <FormControl disabled={view} variant="filled" sx={{ m: 1, minWidth: 260 }} error={error.ProgramTypeValue}>
            <InputLabel id="program-type-label">Program Type (Points/Dollar)</InputLabel>
            <Select
              labelId="program-type-label"
              id="program-type"
              name="ProgramTypeValue"
              value={formState.ProgramTypeValue}
              onChange={handleChange}
            >
              {entityType.ProgramTypeValue.map((item, index) => {
                return (
                  <MenuItem key={index + item.Text} value={item.Text}>
                    {item.Text}
                  </MenuItem>
                );
              })}
            </Select>
            {error.ProgramTypeValue && <FormHelperText>Please select valid Program Type</FormHelperText>}
          </FormControl>

          {rows.length > 0 && (
            <TableContainer sx={{ marginTop: '20px', maxHeight: 450 }}>
              <Table stickyHeader sx={{ minWidth: 650 }} aria-label="simple table">
                <TableHead>
                  <TableRow className="detail__tr">
                    <TableCell sx={{ minWidth: 340 }}>Package Type</TableCell>
                    <TableCell className="text__right">Dev Hrs</TableCell>
                    <TableCell className="text__right">QA Hrs</TableCell>
                    <TableCell className="text__right">Total Hrs</TableCell>
                    <TableCell className="text__right">Total Cost</TableCell>
                  </TableRow>
                </TableHead>

                <TableBody>
                  {rows.map((row, index) => (
                    <TableRow key={index + row.FeatureDescription}>
                      <TableCell>{row.FeatureDescription}</TableCell>
                      <TableCell className="text__right">{row.DevHrs}</TableCell>
                      <TableCell className="text__right">{row.QAHrs}</TableCell>
                      <TableCell className="text__right">{row.TotalHrs}</TableCell>
                      <TableCell className="text__right">{currencyFormatter(row.TotalCost ?? 0)}</TableCell>
                    </TableRow>
                  ))}
                </TableBody>

                <TableFooter>
                  <TableRow className="table__header">
                    <TableCell colSpan={1} className="text__right">
                      Dev/QA Totals
                    </TableCell>
                    <TableCell className="text__right">{devtotal.DevHrs}</TableCell>
                    <TableCell className="text__right">{devtotal.QAHrs}</TableCell>
                    <TableCell className="text__right">{devtotal.TotalHrs}</TableCell>
                    <TableCell className="text__right">{currencyFormatter(devtotal.TotalCost)}</TableCell>
                  </TableRow>

                  {/* <TableRow>
                    <TableCell colSpan={1} className="text__right">
                      PM
                    </TableCell>
                    <TableCell className="text__right"></TableCell>
                    <TableCell className="text__right"></TableCell>
                    <TableCell className="text__right">{pmTotal.pmHrs.toFixed(1)}</TableCell>
                    <TableCell className="text__right">{currencyFormatter(Math.round(pmTotal.pmCost))}</TableCell>
                  </TableRow> */}

                  {/* <TableRow>
                    <TableCell colSpan={1} className="text__right">
                      BA/PO
                    </TableCell>
                    <TableCell className="text__right"></TableCell>
                    <TableCell className="text__right"></TableCell>
                    <TableCell className="text__right"></TableCell>
                    <TableCell className="text__right">{currencyFormatter(0)}</TableCell>
                  </TableRow> */}

                  {/* <TableRow>
                    <TableCell colSpan={1} className="text__right">
                      Lead Dev
                    </TableCell>
                    <TableCell className="text__right"></TableCell>
                    <TableCell className="text__right"></TableCell>
                    <TableCell className="text__right">{leadDevTotal.leadDevHrs.toFixed(1)}</TableCell>
                    <TableCell className="text__right">{currencyFormatter(Math.round(leadDevTotal.leadDevCost))}</TableCell>
                  </TableRow> */}

                  {/* <TableRow>
                    <TableCell colSpan={1} className="text__right">
                      Architect
                    </TableCell>
                    <TableCell className="text__right"></TableCell>
                    <TableCell className="text__right"></TableCell>
                    <TableCell className="text__right"></TableCell>
                    <TableCell className="text__right">{currencyFormatter(0)}</TableCell>
                  </TableRow> */}

                  {/* <TableRow>
                    <TableCell colSpan={1} className="text__right">
                      UXA
                    </TableCell>
                    <TableCell className="text__right"></TableCell>
                    <TableCell className="text__right"></TableCell>
                    <TableCell className="text__right"></TableCell>
                    <TableCell className="text__right">{currencyFormatter(0)}</TableCell>
                  </TableRow> */}

                  {/* <TableRow className="table__header">
                    <TableCell colSpan={1} className="text__right">
                      Total Hours
                    </TableCell>
                    <TableCell className="text__right"></TableCell>
                    <TableCell className="text__right"></TableCell>
                    <TableCell className="text__right">
                      {(devtotal.TotalHrs + pmTotal.pmHrs + leadDevTotal.leadDevHrs).toFixed(1)}
                    </TableCell>
                    <TableCell className="text__right"></TableCell>
                  </TableRow> */}

                  {/* <TableRow>
                    <TableCell colSpan={1} className="text__right">
                      Calculated Cost
                    </TableCell>
                    <TableCell className="text__right"></TableCell>
                    <TableCell className="text__right"></TableCell>
                    <TableCell className="text__right"></TableCell>
                    <TableCell className="text__right">
                      {currencyFormatter(Math.round(devtotal.TotalCost + pmTotal.pmCost + leadDevTotal.leadDevCost))}
                    </TableCell>
                  </TableRow>

                  <TableRow>
                    <TableCell colSpan={1} className="text__right">
                      Timeline
                    </TableCell>
                    <TableCell className="text__right"></TableCell>
                    <TableCell className="text__right"></TableCell>
                    <TableCell className="text__right"></TableCell>
                    <TableCell className="text__right">{`2 Weeks`}</TableCell>
                  </TableRow>

                  <TableRow>
                    <TableCell colSpan={1} className="text__right">
                      Resources - Dev/QA
                    </TableCell>
                    <TableCell className="text__right"></TableCell>
                    <TableCell className="text__right"></TableCell>
                    <TableCell className="text__right"></TableCell>
                    <TableCell className="text__right">{`1.5 Dev/1 QA`}</TableCell>
                  </TableRow>

                  <TableRow className="table__header">
                    <TableCell colSpan={1} className="text__right">
                      Total Cost
                    </TableCell>
                    <TableCell className="text__right"></TableCell>
                    <TableCell className="text__right"></TableCell>
                    <TableCell className="text__right"></TableCell>
                    <TableCell className="text__right">
                      {currencyFormatter(Math.round(36 * 3 * 2 * 42.21 + pmTotal.pmCost + leadDevTotal.leadDevCost))}
                    </TableCell>
                  </TableRow> */}
                </TableFooter>
              </Table>
            </TableContainer>
          )}
        </Box>
      )}
    </>
  );
};

export default ProgramSetup;
